import React from 'react';
import cx from 'classnames';

import './ButtonWithLoading.scss';

class ButtonWithLoading extends React.Component {
  onClick = () => {
    const { isLoading } = this.props;

    // Only propagate the click if we're not already loading
    if (!isLoading) {
      this.props.onClick();
    }
  }

  render() {
    const { children, isLoading, className } = this.props;

    // Conditionnaly display a loader or the button's content
    return (
      <a onClick={this.onClick} className={`ButtonWithLoading ${className || ''}`} disabled={isLoading}>
        { isLoading && <i className="fa fa-circle-o-notch fa-2x fa-spin ButtonWithLoading__Spinner" /> }
        <span
          className={cx('ButtonWithLoading__Children', isLoading && 'ButtonWithLoading__Children--Hidden')}
        >
          {children}
        </span>
      </a>
    );
  }
}

export default ButtonWithLoading;
